import { getLocalStorageItem } from 'hooks';
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpApi from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const userDetails = getLocalStorageItem('roles');
const initialLanguage = userDetails?.account?.language;
i18n
  .use(HttpApi)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: 'en', // Explicitly set the initial language
    fallbackLng: initialLanguage,
    debug: false, // set to false in production
    supportedLngs: ['en', 'de'], // updated from whitelist to supportedLngs
    //  nonExplicitSupportedLngs: true,
    backend: {
      loadPath: process.env.REACT_APP_LOCALES_PATH,
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: false,
    },
  });

// Function to update i18next language
function updateLanguageFromLocalStorage() {
  const updatedUserDetails = getLocalStorageItem('roles');
  const newLanguage = updatedUserDetails?.account?.language;

  // Check if the language has indeed changed and is not undefined
  if (newLanguage && i18n.language !== newLanguage) {
    i18n.changeLanguage(newLanguage);
  }
}

// setInterval(() => {
updateLanguageFromLocalStorage();
// }, 0); // Check every 10 seconds

export default i18n;
